
const ALLOWED_TAGS = new Set([
  "p", "ul", "ol", "li", "strong", "em", "b", "i", "br", "span", "a",
]);

export function sanitizeHTML(dirty) {
  if (!dirty || typeof dirty !== "string") {
    return { __html: "" };
  }

  let clean = dirty;

  // 1. Nuke dangerous block-level elements and their entire content
  clean = clean.replace(
    /<(script|style|iframe|object|embed|form|base|meta|link|svg|math)[\s\S]*?<\/\1\s*>/gi,
    ""
  );
  // Also strip self-closing variants
  clean = clean.replace(
    /<(script|style|iframe|object|embed|form|base|meta|link|svg|math)[^>]*\/?>/gi,
    ""
  );

  // 2. Strip all event handler attributes (onclick, onerror, onload, onmouseover, …)
  clean = clean.replace(/\s+on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi, "");

  // 3. Strip javascript: and data: URI schemes (covers href, src, action, etc.)
  clean = clean.replace(
    /\s*(?:href|src|action|formaction|xlink:href)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi,
    (match) => {
      // Keep safe href values (http/https/relative), strip the rest
      const val = match.replace(/.*=\s*["']?/, "").replace(/["']$/, "");
      if (/^(javascript|data|vbscript):/i.test(val.trim())) return "";
      return match;
    }
  );

  // 4. Strip any tag not in the allowlist
  //    Matches opening tags: <tagname ...> — replaces disallowed ones with ""
  clean = clean.replace(/<\/?([a-zA-Z][a-zA-Z0-9]*)[^>]*>/g, (match, tag) => {
    if (ALLOWED_TAGS.has(tag.toLowerCase())) return match;
    return "";
  });

  return { __html: clean };
}
